import { render, staticRenderFns } from "./modalDashboard.vue?vue&type=template&id=4518f5fa&scoped=true"
import script from "./modalDashboard.vue?vue&type=script&lang=js"
export * from "./modalDashboard.vue?vue&type=script&lang=js"
import style0 from "./modalDashboard.vue?vue&type=style&index=0&id=4518f5fa&prod&lang=scss"
import style1 from "./modalDashboard.vue?vue&type=style&index=1&id=4518f5fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518f5fa",
  null
  
)

export default component.exports